import { createSelector } from 'reselect';
import { State } from 'reducers';

const getUserState =
    (state: State) =>
        state.users
    ;

export const getUsers =
    createSelector(getUserState,
        state => state.data
    );

export type HasUserId = {
    userId: string;
};

const getUserId = (state: State, { userId }: Partial<HasUserId>) => userId;
export const getUser =
    createSelector(
        getUsers,
        getUserId,
        (users, id) => (users && id && users[id]) || null
    );

// TODO: could change this to take into account how long ago users were loaded
export const usersLoadedSelector =
    createSelector(getUserState,
        state => state.loaded
    );

export const getUsersError =
    createSelector(getUserState,
        state => state.error
    );

export const isLoadingUsers =
    createSelector(getUserState,
        state => state.loading.all
    );

export const isLoadingUser =
    createSelector(
        getUserState,
        getUserId,
        (state, userId) => !!(userId && state.loading[userId])
    );

export const getLastSearch =
    createSelector(getUserState,
        state => state && state.lastSearch
    );

export const getLastSearchOrder =
    createSelector(getLastSearch,
        state => (state && state.order) || []
    );

export const getLastSearchMore =
    createSelector(getLastSearch,
        state => state && state.more
    );
